// extracted by mini-css-extract-plugin
export default {"page":"AdminPage_page__C37Ff"};